module.exports = __webpack_public_path__ + "img/wb.ab7ccb95.png";